import _ from 'lodash';

import { CIC_SAVE_NOTE_MAX_LENGTH } from 'constants/cicReason';
import { getDefaultErrorMessage } from 'utils/axios';
import { formatCicDateTime, getCicDisplayValue } from 'utils/cicReason';

import {
  CicNextDisclosureTitle,
  NEXT_DISCLOSURE_FALLBACK_TITLE,
} from '../../LoanCicHistory.constants';
import { getDisclosureShortName } from '../../LoanCicHistory.utils';

import { PENDING_DISCLOSURE_SUFFIX, SAVE_ERROR_MESSAGE } from './CicEditReasonForm.constants';

export const getIsCommentValid = comment => {
  const { length } = (comment ?? '').trim();

  return length > 0 && length <= CIC_SAVE_NOTE_MAX_LENGTH;
};

export const getIsFormChanged = ({ change, cicReasonId, comment }) =>
  cicReasonId !== change.cicReasonId || (comment ?? '').trim() !== (change.comment ?? '');

export const getDialogSubtitle = ({ label, bundleType }) =>
  [
    label,
    CicNextDisclosureTitle[bundleType] ?? NEXT_DISCLOSURE_FALLBACK_TITLE,
    PENDING_DISCLOSURE_SUFFIX,
  ]
    .filter(Boolean)
    .join(' · ');

export const getEditableUntilMessage = ({ bundleType, plannedTriggerDate }) => {
  if (_.isNil(plannedTriggerDate)) {
    return '';
  }

  const shortName = getDisclosureShortName(bundleType);

  return `Editable until the aggregation window closes ${formatCicDateTime(plannedTriggerDate)}. After the Revised ${shortName} is sent the reason is locked.`;
};

export const getSaveErrorMessage = error =>
  _.castArray(getDefaultErrorMessage(error) ?? []).join(' ') || SAVE_ERROR_MESSAGE;

export const getEnteredByLabel = ({ changedByName, changedDate }) =>
  `${getCicDisplayValue(changedByName)} · ${formatCicDateTime(changedDate)}`;
